<template>
    <div id="ai-assistant" v-if="suggestion" @click="select">
        <div class="icon" :class="{ loading }">
            <span class="material-icons"> auto_fix_high </span>
        </div>
        <div
            class="suggestion-text"
            v-show="suggestion"
            v-tippy="{ followCursor: true, placement: 'bottom-end' }"
            :content="suggestion"
        >
            {{ suggestion }}
        </div>
        <div class="actions">
            <span
                class="material-icons"
                v-tippy="{ followCursor: true, placement: 'bottom-end' }"
                content="Bu mesaj  yapay zeka tarafından otomatik olarak oluşturulmuştur.Seçmek için üzerine tıkla veya CTRL + Enter tuşlarına bas."
            >
                help_outline
            </span>
            <div id="keyboard-shortcut">⌘ + ⏎</div>
        </div>
    </div>
</template>
<script>
import Vue from "vue";
import { sendSocketMessage, socketMessageStream } from "../../utils/socketStream";
import { filter, map } from "rxjs/operators";
import { mapState } from "vuex";
import * as _ from "lodash";

export default Vue.extend({
    name: "AIAssistant",
    props: {
        conversationId: {
            type: String,
            required: true,
        },
        messages: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            suggestion: null,
            loading: false,
            cancels: [],
        };
    },
    computed: {
        ...mapState({
            user: (state) => state.auth.user,
            settings: (state) => state.setting.settings,
            site: (state) => state.site.site,
            activeConversation: (state) =>
                state.app.fakeMode ? state.chat.fakeActiveConversation : state.chat.activeConversation,
        }),
    },
    methods: {
        select() {
            this.$emit("select", this.suggestion);
        },
        getSuggestion() {
            this.loading = true;
            sendSocketMessage("user ai-complete", {
                siteId: this.site._id,
                conversationId: this.conversationId,
                userId: this.user._id,
                lastMessages: this.messages.filter(
                    (x) =>
                        ["user", "visitor"].includes(x.messageType) &&
                        (x.conversationId === this.conversationId || x.conversation === this.conversationId)
                ),
            });
        },
        bindCallbacks() {
            this.sub = socketMessageStream
                .pipe(
                    filter((x) => x.cmd === "ai_complete"),
                    map((x) => x.data)
                )
                .subscribe((x) => {
                    if (x.conversationId === this.conversationId) {
                        this.loading = false;
                        this.suggestion = x.response;
                    }
                });

            //listen command + enter
            const keydownCallback = (e) => {
                console.log("keydown", e);
                if (e.metaKey && e.keyCode === 13) {
                    if (this.suggestion) this.select();
                }
            };
            window.addEventListener("keydown", keydownCallback);
            this.cancels.push(() => {
                window.removeEventListener("keydown", keydownCallback);
                this.sub.unsubscribe();
            });
        },
    },
    mounted() {
        this.bindCallbacks();
        const isLastMessageFromVisitor = _.last(this.messages)?.messageType === "visitor";
        if (isLastMessageFromVisitor) this.getSuggestion();
    },
    beforeDestroy() {
        this.cancels.forEach((x) => x());
    },
    watch: {
        messages: {
            handler() {
                const isLastMessageFromVisitor = _.last(this.messages)?.messageType === "visitor";
                if (isLastMessageFromVisitor && !this.loading) {
                    this.getSuggestion();
                } else {
                    this.suggestion = null;
                    this.loading = false;
                }
            },
            deep: true,
        },
        conversationId() {
            this.suggestion = null;
            this.loading = false;
            this.getSuggestion();
        },
    },
});
</script>

<style scoped lang="scss">
#ai-assistant {
    display: flex;
    justify-content: space-between;
    align-items: center;
    align-content: center;
    cursor: pointer;
    padding: 0 10px;

    .icon,
    .actions {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 5px;

        .material-icons {
            font-size: 18px;
        }

        #keyboard-shortcut {
            height: 18px;
            margin: 0px;
            padding: 0px 5px;
        }
    }

    .suggestion-text {
        white-space: nowrap;
        display: -webkit-box;
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-line-clamp: 1;
        width: calc(100% - 100px);
    }

    .icon {
        &.loading {
            //generate highlight animation for material icons
            @keyframes highlight {
                0% {
                    color: #ffa800;
                }
                50% {
                    color: #ffa800;
                }
                100% {
                    color: #000;
                }
            }

            .material-icons {
                animation: highlight 1s infinite;
            }
        }
    }
}
</style>
